import { useRef, useEffect } from "react";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";
import { useHookstate } from "@hookstate/core";

export function useStartTimer() {
  useInterval(() => {
    rootComponentsStore.timer.set(Date.now());
  }, 1000);
}

export function useTimer() {
  return useHookstate(rootComponentsStore.timer).get();
}

export function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
